export default __webpack_public_path__ + "static/media/textsearch_locked_crown.4509b566.svg";